import React from 'react';
import { getUILoc } from '../utils/cardUtils.js';
import audioManager from '../utils/AudioManager.js';

const TutorialSelectionScreen = ({ gameData, onStartTutorial, onExit }) => {
    // gameData がなければ何も表示しない
    if (!gameData || !gameData.tutorialMaster) {
        return <div>{getUILoc('MESSAGES.TUTORIAL_LOADING')}</div>;
    }

    const tutorials = gameData.tutorialMaster;

    const handleTutorialClick = (tutorialId) => {
        audioManager.playSE('select');
        onStartTutorial(tutorialId);
    };

    const handleExit = () => {
        audioManager.playSE('cancel');
        onExit();
    };

    return (
        <div className="deck-selection-screen tutorial-selection-screen">
            <div className="screen-header">
                <h1>{getUILoc('SCREENS.TUTORIAL_SELECTION')}</h1>
                <button onClick={handleExit} className="back-button">{getUILoc('BUTTONS.BACK')}</button>
            </div>
            <div className="deck-selection-area">
                <div className="deck-grid">
                    {tutorials.map(tutorial => (
                        <div key={tutorial.tutorialId} className="deck-card" onClick={() => handleTutorialClick(tutorial.tutorialId)}>
                            <h3>{getUILoc(tutorial.title)}</h3>
                            <p className="deck-description">{getUILoc(tutorial.description)}</p>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default TutorialSelectionScreen;
